<script>
import feather from 'feather-icons';

export default {
	name: 'Home',
	data: () => {
		return {
			theme: '',
		};
	},
	created() {
		this.theme = localStorage.getItem('theme') || 'light';
	},
	mounted() {
		feather.replace();
		this.theme = localStorage.getItem('theme') || 'light';
	},
	updated() {
		feather.replace();
	},
	methods: {},
};
</script>

<template>
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
	<section class="flex flex-col sm:justify-between items-center sm:flex-row mt-12 sm:mt-10" id="banner">
		<!-- Banner left contents -->
		<div class="w-full md:w-3/4 text-left mx-10 p-10">
			<h2 class="
				font-general-light
				text-2xl
				md:text-2xl
				xl:text-3xl
				text-center
				sm:text-left
				text-ternary-dark
				dark:text-primary-light
				mb-4
				tracking-wider
				">
				Hi, I'm
			</h2>
			<h1 class="
				font-general-semibold
				text-6xl
				md:text-6xl
				xl:text-7xl
				text-center
				sm:text-left
				text-ternary-dark
				dark:text-primary-light
				mb-4
				tracking-wider
				">
				Allen Tao
			</h1>
			<p class="
				font-general-medium
				mt-2
				text-lg
				sm:text-xl
				xl:text-2xl
				text-center
				sm:text-left
				leading-normal
				text-gray-500
				dark:text-gray-200
				tracking-wider
				">
				I am passionate about building practical robots capable and general enough to perform meaningful tasks in the real world.
				<br/><br/>
				I studied Robotics and AI Engineering at the University of Toronto, where I was the Technical Director of Perception on the <a class="text-blue-600 font-general-semibold no-underline hover:underline" target="_blank"
                            href="https://news.engineering.utoronto.ca/u-of-t-engineerings-self-driving-car-team-takes-top-spot-at-international-championship/">University of Toronto Self-Driving Car Team</a>, researching how to generalize LiDAR perception to unseen environments.
				<br/><br/>
				I was fortunate to work on several industry and research projects focused on the application of AI to robotics, including <a class="text-blue-600 font-general-semibold no-underline hover:underline" target="_blank" href="https://www.tesla.com/fsd">Tesla AI</a> and <a class="text-blue-600 font-general-semibold no-underline hover:underline" target="_blank" href="https://epson.com/markham-research-development">Epson R&D</a>, as well as research at <a class="text-blue-600 font-general-semibold no-underline hover:underline" target="_blank" href="https://www.trailab.utias.utoronto.ca/">TRAILab</a>, <a class="text-blue-600 font-general-semibold no-underline hover:underline" target="_blank" href="https://rvl.cs.toronto.edu/">RVL</a>, <a class="text-blue-600 font-general-semibold no-underline hover:underline" target="_blank" href="http://asrl.utias.utoronto.ca/">ASRL</a>, and <a class="text-blue-600 font-general-semibold no-underline hover:underline" target="_blank" href="https://www.dynsyslab.org/vision-news/">LSL</a>.	
			</p>
			<div class="
				font-general-medium
				mt-2
				text-lg
				sm:text-xl
				xl:text-2xl
				text-center
				sm:text-left
				leading-normal
				text-gray-500
				dark:text-gray-200
				tracking-wider
				">
			</div>
		</div>
	</section>

    <!-- Experience -->
    <!--
    <section class="
        flex flex-col
        sm:justify-between
        items-center
        sm:flex-row
        mt-12
        sm:mt-10
        " id="experience">
        <div class="w-full mx-10 p-10">
            <h2 class="
                font-general-semibold
                text-4xl
                md:text-4xl
                xl:text-5xl
                text-center
                sm:text-left
                text-ternary-dark
                dark:text-primary-light
                mb-4
                tracking-wider
            ">
                Experience
            </h2>
            <div class="flex flex-row items-center mb-10">
                <div class="w-1/6 sm:w-1/8 md:w-1/12 flex justify-center">
                    <img src="@/assets/images/tesla.png" alt="Tesla Autopilot" class="rounded " />
                </div>
                <div class="w-5/6 sm:w-7/8 md:w-11/12 ml-4">
                    <p class="
                        font-general-medium
                        text-lg
                        sm:text-xl
                        xl:text-2xl
                        text-left
                        sm:text-left
                        leading-none
                        text-gray-500
                        dark:text-gray-200
                        tracking-wider">
                        <b class="font-general-semibold">Machine Learning Intern</b> @ 
                        <a class="text-blue-600 font-general-semibold no-underline hover:underline"
                            href="https://www.tesla.com/" target="_blank">Tesla Autopilot</a>
                        <br>
                        <span class="text-sm text-gray-400">May 2025 – Aug 2025</span>
                        <br>
                        <span>Foundation Models for end-to-end vision only Full Self-Driving (FSD) used for RoboTaxi launch</span>
                    </p>
                </div>
            </div>
            <div class="flex flex-row items-center mb-10">
                <div class="w-1/6 sm:w-1/8 md:w-1/12 flex justify-center">
                    <img src="@/assets/images/epson.png" alt="Epson Edge Logo" class="rounded" />
                </div>
                <div class="w-5/6 sm:w-7/8 md:w-11/12 ml-4">
                    <p class="
                        font-general-medium
                        text-lg
                        sm:text-xl
                        xl:text-2xl
                        text-left
                        sm:text-left
                        leading-none
                        text-gray-500
                        dark:text-gray-200
                        tracking-wider">
                        <b class="font-general-semibold">Machine Learning Software Developer</b> @ 
                        <a class="text-blue-600 font-general-semibold no-underline hover:underline"
                            href="https://epson.ca/markham-research-development" target="_blank">Epson Edge</a> (Epson's R&D wing)
                        <br>
                        <span class="text-sm text-gray-400">May 2024 – April 2025</span>
                        <br>
                        <span>Researching vision language models and high precision manipulator robotics</span>
                    </p>
                </div>
            </div>
            <div class="flex flex-row items-center mb-10">
                <div class="w-1/6 sm:w-1/8 md:w-1/12 flex justify-center">
                    <img src="@/assets/images/rvl.png" alt="RVL Logo" class="rounded" />
                </div>
                <div class="w-5/6 sm:w-7/8 md:w-11/12 ml-4">
                    <p class="
                        font-general-medium
                        text-lg
                        sm:text-xl
                        xl:text-2xl
                        text-left
                        sm:text-left
                        leading-none
                        text-gray-500
                        dark:text-gray-200
                        tracking-wider">
                        <b class="font-general-semibold">Undergraduate Researcher</b> @ 
                        <a class="text-blue-600 font-general-semibold no-underline hover:underline"
                            href="https://rvl.cs.toronto.edu/" target="_blank">Robot Vision and Learning Lab</a>
                        <br>
                        <span class="text-sm text-gray-400">May 2024 – August 2024</span>
                        <br>
                        <span>Worked on perception for automated domain inference in robotics with Prof. Florian Shkurti</span>
                    </p>
                </div>
            </div>
            <div class="flex flex-row items-center mb-10">
                <div class="w-1/6 sm:w-1/8 md:w-1/12 flex justify-center">
                    <img src="@/assets/images/asrl.png" alt="ASRL Logo" class="rounded" />
                </div>
                <div class="w-5/6 sm:w-7/8 md:w-11/12 ml-4">
                    <p class="
                        font-general-medium
                        text-lg
                        sm:text-xl
                        xl:text-2xl
                        text-left
                        sm:text-left
                        leading-none
                        text-gray-500
                        dark:text-gray-200
                        tracking-wider">
                        <b class="font-general-semibold">Undergraduate Researcher</b> @ 
                        <a class="text-blue-600 font-general-semibold no-underline hover:underline"
                            href="http://asrl.utias.utoronto.ca/" target="_blank">Autonomous Space Robotics Laboratory</a>
                        <br>
                        <span class="text-sm text-gray-400">May 2023 – Jan 2024</span>
                        <br>
                        <span>Investigated LiDAR-based indoor navigation for autonomous robots under Prof. Tim Barfoot</span>
                    </p>
                </div>
            </div>
            <div class="flex flex-row items-center mb-10">
                <div class="w-1/6 sm:w-1/8 md:w-1/12 flex justify-center">
                    <img src="@/assets/images/lsl.png" alt="LSL Logo" class="rounded" />
                </div>
                <div class="w-5/6 sm:w-7/8 md:w-11/12 ml-4">
                    <p class="
                        font-general-medium
                        text-lg
                        sm:text-xl
                        xl:text-2xl
                        text-left
                        sm:text-left
                        leading-none
                        text-gray-500
                        dark:text-gray-200
                        tracking-wider">
                        <b class="font-general-semibold">Summer Researcher</b> @ 
                        <a class="text-blue-600 font-general-semibold no-underline hover:underline"
                            href="https://www.dynsyslab.org/vision-news/" target="_blank">Learning Systems and Robotics Lab</a>
                        <br>
                        <span class="text-sm text-gray-400">May 2022 - Aug 2022</span>
                        <br>
                        <span>Worked on control barrier functions and code reproducibility in robotics research, supervised by Prof. Angela Schoellig</span>
                    </p>
                </div>
            </div>
        </div>
    </section>
    -->



	<!-- Education -->
	<section class="
      flex flex-col
      sm:justify-between
      items-center
      sm:flex-row
      mt-12
      sm:mt-10
    " id="education">
		<div class="w-full mx-10 p-10">
			<h2 class="
            font-general-semibold
            text-4xl
            md:text-4xl
            xl:text-5xl
            text-center
            sm:text-left
            text-ternary-dark
            dark:text-primary-light
            mb-4
            tracking-wider
          ">
				Education
			</h2>
			<div class="flex flex-row items-center">
				<div class="w-1/3">
					<img v-if="theme === 'light'" src="@/assets/images/UofT-Crest-Square.png"
						alt="University of Toronto Crest" style="width: 150px; height: auto;" />
					<img v-else src="@/assets/images/UofT-Crest-Square-Light.png" alt="University of Toronto Crest" style="width: 100px; height: auto;" />
				</div>
				<div class="w-2/3 ml-4">
					<p class="
                font-general-medium
                text-lg
                sm:text-xl
                xl:text-2xl
                text-left
                sm:text-left
                leading-none
                text-gray-500
				dark:text-gray-200
                tracking-wider
              ">
						<b class="font-general-semibold">University of Toronto</b> <span
							class="font-general-light">(cGPA:
							3.97/4.0)</span><br>
					</p>
					<ul class="font-general-medium
									text-lg
									sm:text-xl
									xl:text-2xl
									text-left
									sm:text-left
									leading-none
									text-gray-500
									dark:text-gray-200
									tracking-wider 
									list-disc 
									pl-10">
						<li>BASc. in <a href="https://engsci.utoronto.ca/program/what-is-engsci/" target="_blank"
								class="font-general-semibold text-blue-600 no-underline hover:underline">Engineering
								Science</a>
							| 2021-2026 <br></li>
						<li><b>Robotics </b> Major, <b>Artificial Intelligence</b> Minor <br></li>
					</ul>
					<!-- <p class="
                font-general-medium
                text-lg
                sm:text-xl
                xl:text-2xl
                text-left
                sm:text-left
                leading-none
                text-gray-500
				dark:text-gray-200
                tracking-wider
              ">
						<b>Relevant Courses</b>: <span class="font-general-medium">Deep Learning (PyTorch), Machine
							Learning, Mobile Robotics, Control Systems, Numerical Methods,
							Bayesian & Probabilistic Methods, Dynamics, Embedded Systems, Operating Systems, Digital &
							Computer Systems</span>
					</p> -->
				</div>
			</div>
		</div>
	</section>

	<!-- Publications -->
	<section class="
      flex flex-col
      sm:justify-between
      items-center
      sm:flex-row
      mt-12
      sm:mt-10
    " id="publication">
		<div class="w-full mx-10 p-10">
			<h2 class="
            font-general-semibold
            text-4xl
            md:text-4xl
            xl:text-5xl
            text-center
            sm:text-left
            text-ternary-dark
            dark:text-primary-light
            mb-4
            tracking-wider
          ">
				Research
			</h2>

			<div class="flex flex-row
                    ">

				<div class="w-1/3">
					<img v-if="theme === 'light'" src="@/assets/images/coupled_ekf.png" alt="Perception-control loop for visual servoing." style="width: 150px; height: auto;"  />
					<img v-else src="@/assets/images/coupled_ekf.png" alt="Perception-control loop for visual servoing." style="width: 150px; height: auto;"  />
				</div>

				<div class="w-2/3 ml-4">
					<p class="
                font-general-medium
                text-lg
                sm:text-xl
                xl:text-2xl
                text-left
                sm:text-left
                leading-none
                text-gray-500
			dark:text-gray-200
                tracking-wider
              ">
						<b class="font-general-semibold">Perception-Control Coupled Visual Servoing for Textureless Objects Using Keypoint-Based EKF</b><br>
						<span class="text-sm"><b>Allen Tao</b>*, Jun Yang*†, Stanko Oparnica, Wenjie Xue</span><br>
						<span class="text-xs">* Equal contribution &nbsp;† Project lead</span><br>
						<span class="text-sm">ICRA 2026</span><br>
						<a target="_blank"
							class="text-sm font-general-semibold text-blue-600 no-underline hover:underline"
							href="https://arxiv.org/abs/2602.06834">
							<i class="fas fa-file-pdf mr-2"></i>
							Paper Link
						</a>
						&nbsp;·&nbsp;
						<a target="_blank"
							class="text-sm font-general-semibold text-red-600 no-underline hover:underline"
							href="https://youtu.be/cpjuMvijxNc?si=3ctQfXMCSdcaXfN0">
							<i class="fab fa-youtube mr-2"></i>
							Video
						</a>
					</p>
				</div>

			</div>

			<br>

			<div class="flex flex-row
                    ">

				<div class="w-1/3">
					<img v-if="theme === 'light'" src="@/assets/images/tamp.png" alt="Robot executing on learned domain from demonstration." style="width: 150px; height: auto;"  />
					<img v-else src="@/assets/images/tamp.png" alt="Robot executing on learned domain from demonstration." style="width: 150px; height: auto;"  />
				</div>

				<div class="w-2/3 ml-4">
					<p class="
                font-general-medium
                text-lg
                sm:text-xl
                xl:text-2xl
                text-left
                sm:text-left
                leading-none
                text-gray-500
				dark:text-gray-200
                tracking-wider
              ">
						<b class="font-general-semibold">Automated Planning Domain Inference for Task and Motion Planning</b><br>
						<span class="text-sm">Jinbang Huang, <b>Allen Tao</b>, Rozilyn Marco, Miroslav Bogdanovic, Jonathan Kelly, Florian Shkurti</span><br>
						<span class="text-sm">ICRA 2025</span><br>
						<a target="_blank"
							class="text-sm font-general-semibold text-blue-600 no-underline hover:underline"
							href="https://arxiv.org/abs/2410.16445">
							<i class="fas fa-file-pdf mr-2"></i>
							Paper Link
						</a>
					</p>
				</div>

			</div>

			<br>

			<div class="flex flex-row
                    ">

				<div class="w-1/3">
					<img v-if="theme === 'light'" src="@/assets/images/costmap.png" alt="Robot proactively avoiding chair." style="width: 150px; height: auto;"  />
					<img v-else src="@/assets/images/costmap.png" alt="Robot proactively avoiding chair." style="width: 150px; height: auto;" />
				</div>

				<div class="w-2/3 ml-4">
					<p class="
                font-general-medium
                text-lg
                sm:text-xl
                xl:text-2xl
                text-left
                sm:text-left
                leading-none
                text-gray-500
				dark:text-gray-200
                tracking-wider
              ">
						<b class="font-general-semibold">MakeWay: Object-Aware Costmaps for Proactive Indoor Navigation
							Using LiDAR</b><br>
						<span class="text-sm">Binbin Xu, <b>Allen Tao</b>, Hugues Thomas, Jian Zhang, Timothy D. Barfoot</span><br>
						<span class="text-sm">CRV 2025 (Oral)</span><br>
						<a target="_blank"
							class="text-sm font-general-semibold text-blue-600 no-underline hover:underline"
							href="https://www.arxiv.org/abs/2408.17034">
							<i class="fas fa-file-pdf mr-2"></i>
							Paper Link
						</a>
					</p>
				</div>

			</div>

			<br>

			<div class="flex flex-row
                    ">

				<div class="w-1/3">
					<img v-if="theme === 'light'" src="@/assets/images/opinion.png" alt="Citations vs. Stars" style="width: 150px; height: auto;"/>
					<img v-else src="@/assets/images/opinion.png" alt="Citations vs. Stars" style="width: 150px; height: auto;"/>
				</div>

				<div class="w-2/3 ml-4">
					<p class="
                font-general-medium
                text-lg
                sm:text-xl
                xl:text-2xl
                text-left
                sm:text-left
                leading-none
                text-gray-500
				dark:text-gray-200
                tracking-wider
              ">
						<b class="font-general-semibold">What is the Impact of Releasing Code with Publications?
							Statistics from the Machine Learning, Robotics, and Control Communities</b><br>
						<span class="text-sm">Siqi Zhou, Lukas Brunke, <b>Allen Tao</b>, Adam W. Hall, Federico Pizarro
							Bejarano, Jacopo Panerati, Angela P. Schoellig</span><br>
						<span class="text-sm">IEEE Control Systems Magazine</span><br>
						<a target="_blank"
							class="text-sm font-general-semibold text-blue-600 no-underline hover:underline"
							href="https://arxiv.org/abs/2308.10008">
							<i class="fas fa-file-pdf mr-2"></i>
							Paper Link
						</a>
					</p>
				</div>

			</div>
		</div>
	</section>


</template>

<style scoped></style>